import { http } from 'http';

export default {
  validateCookie: id => http.get(`/webh/campaigns/ValidateCookie?id=${id}`),

  getStateProcess: params => {
    const emailFormatted = encodeURIComponent(params.email);
    return http.get(
      `/webh/campaigns/GetStateProcess?identityCard=${params.identityCard}&email=${emailFormatted}&id=${params.id}`
    );
  },

  operationByGUID: guid => http.get(`/webh/operations/${guid}`),

  precontractByGUID: guid => http.get(`webh/operations/precontract?id=${guid}`),

  errorKOByGUID: guid => http.get(`/webh/operations/error/${guid}`),

  campaignFront: params => http.get(`/webh/campaigns/front/${params.id}/${params.partnerid}`),

  campaignFrontByOrderId: params =>
    http.get(
      `/webh/campaigns/front/${params.id}/${params.partnerId}?orderId=${params.orderId}&access_token=${params.accessToken}`
    ),

  campaignFrontByGuid: guid => http.get(`/webh/campaigns/front/${guid}`),

  validationStock: guid => http.get(`/validation/stock/${guid}`),

  legalConditions: params => http.get(`/campaigns/${params.idOffer}/consentsgroups/${params.step}`),

  legalConditionsByGuid: params =>
    http.get(`/operations/${params.guid}/consentsgroups/${params.step}`),

  componentsByPartnerId: (id, partnerId) =>
    http.get(`/cms/${process.env.APP_LOCALE}/templates/${id}/patterns`, {
      headers: { AppId: process.env.APP_ID, PartnerId: partnerId }
    }),

  getMasterData: () => http.get('/masterdata'),

  getBasicsByPartnerId: params =>
    http.get(`/basics${params && params.partnerId ? `/${params.partnerId}` : ''}`),

  riskAnalysis: params =>
    http.get(
      `/webh/campaigns/RiskAnalysis?id=${params.guid}&idTransSancion=${params.idRequestInstantor}`
    ),

  documentsRequiredByGuid: params => http.get(`/operations/${params.guid}/risk/${params.step}`),

  getTownsByCp: cp => http.get(`/towns/${cp}`),

  getTownsByProvinceCode: provinceCode =>
    http.get(`/operations/GetPoblacionesByProvinceCode?provinceCode=${provinceCode}`)
};
